import set from 'transmute/set';
export const setIsFirstVisitorSession = set('isFirstVisitorSession');